<template>
  <div class="wrap" ref="wrap">
    <PlayPause :action="playPause" :is-paused="!playState" />
    <canvas id="copy" ref="canvasCopy"></canvas>
    <div class="rounded-corner" ref="corner">
      <svg
        width="200"
        height="200"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 200C110.457 200 200 110.457 200 0V200H0Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import GSAP from "gsap";
// import vertexShader from "../shaders/vertex.glsl";
// import fragmentShader from "../shaders/fragment.glsl";
import vertexShader from "raw-loader!glslify-loader!../shaders/vertex.glsl";
import fragmentShader from "raw-loader!glslify-loader!../shaders/fragment.glsl";
import { store } from "@/store/scene.js";
import PlayPause from "./ui/PlayPause.vue";

export default {
  name: "Scene",
  components: {
    PlayPause,
  },
  data() {
    return {
      store,

      viewport: {
        width: 1920,
        height: 1920,
      },
      playState: true,
    };
  },
  watch: {
    "store.color"(newVal) {
      if (newVal) {
        this.mesh.material.uniforms.iColor.value.x = newVal[0] / 255;
        this.mesh.material.uniforms.iColor.value.y = newVal[1] / 255;
        this.mesh.material.uniforms.iColor.value.z = newVal[2] / 255;
      }
    },
    "store.bgColor"(newVal) {
      if (newVal) {
        this.mesh.material.uniforms.iBgColor.value.x = newVal[0] / 255;
        this.mesh.material.uniforms.iBgColor.value.y = newVal[1] / 255;
        this.mesh.material.uniforms.iBgColor.value.z = newVal[2] / 255;
      }
    },
    "store.transparency"(newVal) {
      this.mesh.material.uniforms.iTransparency.value = newVal;
    },
    "store.imageDimension"(newVal) {
      if (newVal) {
        let newDimensions = newVal.split(/[a-z]\w+-|x/).filter(Boolean);
        this.viewport.width = newDimensions[0];
        this.viewport.height = newDimensions[1];
        this.resizeFn();
      }
    },
    "store.rounded"(newVal) {
      console.log(newVal);
      if (newVal) {
        this.$refs.corner.style.opacity = 1;
      } else {
        this.$refs.corner.style.opacity = 0;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => this.resizeFn());

    this.initScene();
  },
  methods: {
    resizeFn() {
      this.camera.aspect = this.viewport.width / this.viewport.height;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(this.viewport.width, this.viewport.height);
      this.canvas.style.width = "100%";
      this.canvas.style.height = "100%";
      this.canvas.style.position = "absolute";

      this.$refs.canvasCopy.style.width = this.viewport.width;
      this.$refs.canvasCopy.style.height = this.viewport.height;
      this.$refs.canvasCopy.style.position = "absolute";

      this.$refs.canvasCopy.width = this.viewport.width;
      this.$refs.canvasCopy.height = this.viewport.height;

      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
    },
    initScene() {
      this.scene = new THREE.Scene();

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
        preserveDrawingBuffer: true,
      });

      this.canvas = this.renderer.domElement;
      this.canvas.classList.add("webgl");

      this.$refs.wrap.appendChild(this.canvas);
      store.canvas = this.canvas;
      store.canvasCopy = this.$refs.canvasCopy;

      this.camera = new THREE.PerspectiveCamera(
        75,
        this.viewport.width / this.viewport.height,
        0.1,
        10
      );
      this.camera.position.set(0, 0, 0.5);
      this.scene.add(this.camera);

      this.clock = new THREE.Clock();

      ///WITH SHAPE
      // const x = 0,
      //   y = 0;

      // const heartShape = new THREE.Shape();

      // heartShape.moveTo(x + 0.5, y + 0.5);
      // heartShape.bezierCurveTo(x + 0.5, y + 0.5, x + 0.4, y, x, y);
      // heartShape.bezierCurveTo(x - 0.6, y, x - 0.6, y + 0.7, x - 0.6, y + 0.7);
      // heartShape.bezierCurveTo(
      //   x - 0.6,
      //   y + 1.1,
      //   x - 0.3,
      //   y + 1.54,
      //   x + 0.5,
      //   y + 1.9
      // );
      // heartShape.bezierCurveTo(
      //   x + 1.2,
      //   y + 1.54,
      //   x + 1.6,
      //   y + 1.1,
      //   x + 1.6,
      //   y + 0.7
      // );
      // heartShape.bezierCurveTo(x + 1.6, y + 0.7, x + 1.6, y, x + 1.0, y);
      // heartShape.bezierCurveTo(x + 0.7, y, x + 0.5, y + 0.5, x + 0.5, y + 0.5);

      this.geometry = new THREE.PlaneGeometry(3, 3, 50);

      this.material = new THREE.ShaderMaterial({
        blending: THREE.NormalBlending,
        transparent: true,
        vertexShader,
        fragmentShader,
        side: THREE.DoubleSide,
        uniforms: {
          iResolution: {
            value: new THREE.Vector2(this.viewport.height, this.viewport.width),
          },
          iTime: { value: 1.0 },
          iBrightness: { value: this.store.brightness },
          iFrequency: { value: this.store.frequency },
          iAmplitude: { value: this.store.amplitude },
          iVelocity: { value: this.store.velocity },
          iColor: {
            value: new THREE.Vector3(this.store.color),
          },
          iBgColor: {
            value: new THREE.Vector3(this.store.bgColor),
          },
          iTransparency: {
            value: 0,
          },
        },
      });

      this.mesh = new THREE.Mesh(this.geometry, this.material);
      this.scene.add(this.mesh);
      this.mesh.material.uniforms.iColor.value.x = this.store.color[0] / 255;
      this.mesh.material.uniforms.iColor.value.y = this.store.color[1] / 255;
      this.mesh.material.uniforms.iColor.value.z = this.store.color[2] / 255;

      this.resizeFn();
      this.update();
    },
    /**
     * LOOP
     */
    update() {
      if (this.playState) {
        const elapsedTime = this.clock.getElapsedTime();

        GSAP.to(this.mesh.material.uniforms.iTime, { value: elapsedTime });
        GSAP.to(this.mesh.material.uniforms.iBrightness, {
          value: this.store.brightness,
        });
        GSAP.to(this.mesh.material.uniforms.iFrequency, {
          value: this.store.frequency,
        });
        GSAP.to(this.mesh.material.uniforms.iAmplitude, {
          value: this.store.amplitude,
        });
        GSAP.to(this.mesh.material.uniforms.iVelocity, {
          value: this.store.velocity,
        });
      }
      this.render();

      //copy canvas by DataUrl

      window.requestAnimationFrame(this.update);
    },

    /**
     * RENDER
     */
    render() {
      this.renderer.render(this.scene, this.camera);
    },
    playPause() {
      this.playState = !this.playState;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrap {
  flex: 1;
  overflow: hidden;
  display: flex;
  width: 100%;
  position: relative;
}
#copy {
  right: 0;
  top: 0;
  z-index: -1;
  pointer-events: none;
  opacity: 0;
}
.rounded-corner {
  position: absolute;
  bottom: 90px;
  right: 0;
  height: 120px;
  width: 120px;
  z-index: 3;
  opacity: 0;
  transition: opacity 0.5s ease-out;
}
.rounded-corner svg {
  display: block;
  width: 100%;
  height: auto;
}
</style>
